import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="py-20 relative overflow-hidden" data-id="element-113">
      {/* Decorative Elements */}
      <span className="absolute top-4 right-8 text-3xl opacity-[0.07] pointer-events-none select-none" data-id="element-114">
        💤
      </span>
      <span className="absolute bottom-4 left-4 text-3xl opacity-[0.06] pointer-events-none select-none" data-id="element-115">
        ☕
      </span>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-116">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="border-l-4 border-emerald-500 pl-6 md:pl-10 py-2" data-id="element-117">
          <p className="text-xl md:text-2xl text-gray-200 leading-relaxed mb-6 font-light" data-id="element-118">
            Son las 4:00 de la tarde y sientes que el día ya terminó para ti. No
            es falta de voluntad, no es una enfermedad y, a pesar de lo que te
            han dicho, no es "normal por la edad". Es el sonido de tu
            metabolismo entrando en modo de hibernación defensiva.
          </p>
          <p className="text-xl md:text-2xl text-gray-200 leading-relaxed font-light" data-id="element-119">
            Lo que sientes es una desconexión biológica. Tu cuerpo todavía tiene
            el combustible, pero ha perdido la llave de encendido. Estás
            viviendo con el freno de mano puesto mientras intentas acelerar a
            fondo con cafeína y azúcar.
          </p>
        </motion.div>
      </div>
    </section>;
}